import React, { useState, useRef } from "react";
import { Image } from "react-bootstrap";
import { Stack, Panel, Form, Text, Divider, IconButton } from "rsuite";
import PlusIcon from "@rsuite/icons/Plus";
import FileDownloadIcon from "@rsuite/icons/FileDownload";
import * as htmlToImage from "html-to-image";

export const CitaConfirmada = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("dataCita")).id);
  const [uuidCita] = useState(
    JSON.parse(localStorage.getItem("uuidCita")).uuidCita
  );
  const [negocio] = useState(
    JSON.parse(localStorage.getItem("dataCita")).negocio
  );
  const domicilio = useState(
    JSON.parse(localStorage.getItem("dataCita")).domicilio
  );
  const edoMun = useState(JSON.parse(localStorage.getItem("dataCita")).edoMun);

  const [fecha] = useState(JSON.parse(localStorage.getItem("dataCita")).fecha);
  const [hora] = useState(JSON.parse(localStorage.getItem("dataCita")).hora);
  const [telNegocio] = useState(JSON.parse(localStorage.getItem("dataCita")).telNegocio);

  const [nombre] = useState(
    JSON.parse(localStorage.getItem("dataCita")).nombre
  );
  const titulo = `Cita con ${
    JSON.parse(localStorage.getItem("dataCita")).nomConsultorio
  }`;
  const location = JSON.parse(localStorage.getItem("dataCita")).domicilio;
  const details = `Cita agendada en: ${
    JSON.parse(localStorage.getItem("dataCita")).domicilio
  }`;
  const _data = JSON.parse(
    localStorage.getItem("uuidCita")
  ).uuidCita.toString();
  const _fec = _data.split("-");

  const urlAddLink = `https://calendar.google.com/calendar/r/eventedit?text=${titulo}&details=${details}&location=${location}&dates=${_fec[2]}T${_fec[3]}:00/${_fec[2]}T${_fec[3]}:00`;

  const createFileName = (extension = "", ...names) => {
    if (!extension) {
      return "";
    }
    return `${names.join("")}.${extension}`;
  };

  const downloadFile = (image, { name = "Cita", extension = "jpg" } = {}) => {
    const a = document.createElement("a");
    a.href = image;
    a.download = createFileName(extension, name);
    a.click();
  };

  const screenshotArea = useRef(null);

  const handleDownload = async () => {
    if (!screenshotArea.current) return;
    await htmlToImage.toJpeg(screenshotArea.current).then(downloadFile);
    alert("Se ha descargado un documento: Cita.jpg");
  };

  const goTo = (page, windowOut) => {
    if (windowOut === 0) {
      window.location = `/#/${negocio}`;
    } else {
      window.open(page, "_blank");
    }
  };

  return (
    <>
      <div ref={screenshotArea} style={{ backgroundColor: 'white'}}>
        <center>
          <Image
            src="Images/CitaConfirmada.png"
            style={{ height: 60, margin: 10 }}
          />
        </center>
        <Stack
          alignItems="center"
          justifyContent="center"
          style={{ height: "100%" }}
        >
          <Panel style={{ marginTop: 0 }}>
            <Form fluid style={{ fontSize: "18px" }}>
              <Form.Group>
                <Form.ControlLabel>
                  <Text weight="bold" size="lg">
                    Identificador de Cita
                  </Text>
                </Form.ControlLabel>
                <Form.ControlLabel>{uuidCita}</Form.ControlLabel>
              </Form.Group>

              <Form.Group>
                <Form.ControlLabel>
                  <Text weight="bold" size="lg">
                    Fecha y Hora
                  </Text>
                </Form.ControlLabel>
                <Form.ControlLabel>
                  {fecha} a las {hora.substring(0, 5)} Hrs.
                </Form.ControlLabel>
              </Form.Group>

              <Form.Group>
                <Form.ControlLabel>
                  <Text weight="bold" size="lg">
                    Nombre
                  </Text>
                </Form.ControlLabel>
                <Form.ControlLabel>{nombre}</Form.ControlLabel>
              </Form.Group>

              <Divider>
                <Text weight="bold" size="lg">
                  Domicilio
                </Text>
              </Divider>
              <Text size="md" weight="semibold">
                {domicilio}
                <br></br>
                {edoMun}
              </Text>

              <Divider></Divider>

              <Form.Group>
                <Image
                  src={`Images/Negocios/${idNegocio}.png?v=${new Date().getTime()}`}
                  style={{ width: 250 }}
                />
                <br></br>
                <br></br>
                <Text size="sm" color="red">Cancelar enviar WhatsApp al: {telNegocio}</Text>
              </Form.Group>

              <Form.Group>
                <Form.ControlLabel>
                  <IconButton
                    block
                    appearance="default"
                    onClick={() => handleDownload()}
                    icon={<FileDownloadIcon />}
                  >
                    Descargar cita
                  </IconButton>
                </Form.ControlLabel>
              </Form.Group>

              <Form.Group>
                <a href={urlAddLink} target="_blank" rel="noreferrer">
                  Agregar a calendario
                </a>
              </Form.Group>

              <Form.Group>
                <Form.ControlLabel>
                  <IconButton
                    block
                    appearance="default"
                    onClick={() => goTo("", 0)}
                    icon={<PlusIcon />}
                  >
                    Nueva cita
                  </IconButton>
                </Form.ControlLabel>
              </Form.Group>

              {/* <Image
      src="Images/mapPoint.jpg"
      width={"80px"}
      style={{ borderRadius: "10px", cursor: "pointer" }}
      onClick={() => goTo(ubica, 1)}
    />
    <span>
      <Text weight="light">{domicilio}</Text>
      <Text size="md">{estado}</Text>
    </span> */}
            </Form>
          </Panel>
        </Stack>
      </div>
    </>
  );
};
